import React from 'react';
import { type SubscriptionVariant } from '../../lib/types';

type CartTableDetailsCellProps = {
  readonly name: string;
  readonly subscription: SubscriptionVariant;
  readonly subscriptionFrequencyMonthly: string;
  readonly subscriptionFrequencyPrepaid: string;
  readonly subscriptionLengthMonthly: string;
  readonly subscriptionLengthSemiYearly: string;
  readonly subscriptionLengthYearly: string;
};

export function CartTableDetailsCell(props: CartTableDetailsCellProps) {
  let subscriptionFrequency = '';
  let subscriptionLength = '';

  switch (props.subscription) {
    case 'monthly': {
      subscriptionFrequency = props.subscriptionFrequencyMonthly;
      subscriptionLength = props.subscriptionLengthMonthly;
      break;
    }

    case 'biannual': {
      subscriptionFrequency = props.subscriptionFrequencyPrepaid;
      subscriptionLength = props.subscriptionLengthSemiYearly;
      break;
    }

    case 'annual': {
      subscriptionFrequency = props.subscriptionFrequencyPrepaid;
      subscriptionLength = props.subscriptionLengthYearly;
      break;
    }

    case 'annualMonthly': {
      subscriptionFrequency = props.subscriptionFrequencyMonthly;
      subscriptionLength = props.subscriptionLengthYearly;
      break;
    }

    case 'biannualMonthly': {
      subscriptionFrequency = props.subscriptionFrequencyMonthly;
      subscriptionLength = props.subscriptionLengthSemiYearly;
      break;
    }

    // No default
  }

  return (
    <>
      <b>{props.name}</b>
      <p>{subscriptionLength}</p>
      <p>{subscriptionFrequency}</p>
    </>
  );
}
